import { render, staticRenderFns } from "./NewForum.vue?vue&type=template&id=9edeba10&scoped=true&"
import script from "./NewForum.vue?vue&type=script&lang=js&"
export * from "./NewForum.vue?vue&type=script&lang=js&"
import style0 from "./NewForum.vue?vue&type=style&index=0&id=9edeba10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edeba10",
  null
  
)

export default component.exports